module.exports = __webpack_public_path__ + "img/ic_menu.6ba0ce4e.svg";